import { useState } from "react";

import { Eyebrow } from "../components/Text";
import { useAccount } from "../account/lib/queries";

interface View {
  readonly label: string;
  /** An href rather than a typed route: these cross application boundaries, some outside this router. */
  readonly to: string;
}

interface Group {
  readonly group: string;
  readonly items: readonly View[];
}

/** The companion and the moderator panel are per space and per channel, so they are not listed here. */
function groupsFor(handle: string | null | undefined): readonly Group[] {
  return [
    {
      group: "Console",
      items: [
        { label: "Home", to: "/console/home" },
        { label: "Spaces", to: "/console/spaces" },
        { label: "Activities", to: "/console/activities" },
        { label: "Studio", to: "/console/studio" },
        { label: "Account", to: "/console/account" },
      ],
    },
    {
      group: "Other applications",
      items: [
        { label: "Publisher portal", to: "/publisher" },
        { label: "Platform admin", to: "/admin" },
        { label: "Agent, on the machine", to: "/agent/status" },
      ],
    },
    {
      group: "Signed out",
      items: [
        { label: "Public site", to: "/" },
        { label: "Pricing", to: "/pricing" },
        { label: "Activity catalog", to: "/activities" },
        ...(handle == null ? [] : [{ label: "Public profile", to: `/u/${handle}` }]),
      ],
    },
    {
      group: "Reference",
      items: [{ label: "Design kit", to: "/kit" }],
    },
  ];
}

/** Prototype scaffolding, not product navigation. Every other application, in one place. */
export function ViewsPicker() {
  const [open, setOpen] = useState(false);
  const { data: account } = useAccount();
  const groups = groupsFor(account?.handle);

  return (
    <div className="cx-chrome">
      <div className="cx-viewpick">
        <button
          type="button"
          className={open ? "cx-chrome-btn cx-chrome-btn-on" : "cx-chrome-btn"}
          aria-expanded={open}
          onClick={() => {
            setOpen((held) => !held);
          }}
        >
          views
        </button>
        {open ? (
          <div className="cx-viewpick-menu">
            {groups.map((group) => (
              <div key={group.group}>
                <Eyebrow>{group.group}</Eyebrow>
                {group.items.map((item) => (
                  <button
                    type="button"
                    key={item.label}
                    className="cx-viewpick-item"
                    onClick={() => {
                      setOpen(false);
                      window.location.assign(item.to);
                    }}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
